    import { Injectable } from '@angular/core';

    @Injectable({
        providedIn: 'root',
    })

    export class SeaculumAngularFormlyService {

        constructor() { }

        matchValueExpression(val) {
            return val && val.constructor === Array ?
                val.length > 0 ?
                    val[0].id :
                    val :
                val;
        }

    }

